import { INgxMyDpOptions, IMyDateModel} from 'ngx-mydatepicker';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { EmployeeMasterService }  from '../../../shared/HR_ADMIN/Employee/EmployeeMaster.Service';
import { EmployeeDetail } from '../../../shared/HR_ADMIN/Employee/EmployeeDetail.Model';
import { EmployeeEducationalModel } from '../../../shared/HR_ADMIN/Employee/EmployeeEducationalModel';
//Begin For Notification service
import { NotificationsService} from '../../../shared/notifications.service';

@Component({
  selector: 'app-employeel-qualification',
  templateUrl: './employeel-qualification.component.html',
  styleUrls: ['./employeel-qualification.component.css']
})

export class EmployeelQualificationComponent implements OnInit 
{
  AddressRefID:number;
  SuccessStatus:boolean=false;
  SuccessMessage: string ="";
  Tabindex:number=0;
  EduRefId:number =0;
  Formdate :string;
  Todate:string;
  DisableSave :boolean=false;
  myOptions: INgxMyDpOptions = 
  {
    // other options...
    dateFormat: 'dd.mm.yyyy',
  };

  model: any = { date: { year: 2018, month: 10, day: 9 } };

  constructor(public EmployeeMasterService: EmployeeMasterService, private rout: Router, private notificationsService: NotificationsService) {    }

  ngOnInit() 
  {
    if(this.EmployeeMasterService.SharedEmployees.EmployeeEducation==null)
    {
      let EmployeeEducationList : EmployeeEducationalModel[]=[];
      for( var i=0; i<3; i++ )
      {
        let tempeducation = new EmployeeEducationalModel();          
        EmployeeEducationList.push(tempeducation);         
      }
      this.EmployeeMasterService.SharedEmployees.EmployeeEducation=EmployeeEducationList;
    }
    if(this.EmployeeMasterService.SharedEmployees.EmployeeId > 0)
    {
      if(this.EmployeeMasterService.SharedEmployees.EmployeeEducation.length==0)
      {
        let EmployeeEducationList : EmployeeEducationalModel[]=[];
        for( var i=0; i<3; i++ )
        {
          let tempeducation = new EmployeeEducationalModel();          
          EmployeeEducationList.push(tempeducation);         
        }
        this.EmployeeMasterService.SharedEmployees.EmployeeEducation=EmployeeEducationList;
      }
      else
      {
        this.changetdateformat();
      }
    }
    
    if( this.EmployeeMasterService.SaveOrUpdate==1)
    {
      localStorage.setItem('SuccessfullMessage', "Save Successfully");
      this.EmployeeMasterService.SaveOrUpdate=0;
    }
    if( this.EmployeeMasterService.SaveOrUpdate==2)
    {
      localStorage.setItem('SuccessfullMessage', "Update Successfully");
      this.EmployeeMasterService.SaveOrUpdate=0;
    }
    if(localStorage.getItem('SuccessfullMessage'))
    {
      this.SuccessStatus=true;
      this.SuccessMessage =localStorage.getItem('SuccessfullMessage')
      localStorage.removeItem('SuccessfullMessage');
    } 
    this.DisableSave=true;
  }

  AddnweRow()
  {
    let tempeducation = new EmployeeEducationalModel();          
    this.EmployeeMasterService.SharedEmployees.EmployeeEducation.push(tempeducation);  
  }

  // optional date changed callback
  onDateChangedFrom(event: IMyDateModel,i: number): void
  {
    const monthNames = [
      'January', 'February', 'March',
      'April', 'May', 'June', 'July',
      'August', 'September', 'October',
      'November', 'December'
      ];
    var m= event.jsdate.getMonth();
    m=m+1;
    var d= event.jsdate.getDate();
    var y= event.jsdate.getFullYear();
    var fulldate="";
    if(m>=10)
    {
      if(d < 10)
      {
        fulldate= m + '/' + '0'+ d + '/' + y;
      }
      else
      {
        fulldate= m + '/' + d + '/' + y; 
      }
    }
    else
    {
      if(d < 10)
      {
        fulldate= '0' + m + '/' + '0'+ d + '/' + y;
      }
      else
      {
        fulldate= '0' + m + '/' + d + '/' + y; 
      } 
    }
    this.EmployeeMasterService.SharedEmployees.EmployeeEducation[i].FromDatepass=fulldate;
     //event.formatted = event.jsdate.getDate() + ' ' +     monthNames[event.jsdate.getMonth()] + ', ' + event.jsdate.getFullYear();
  }

  onDateChangedTo(event: IMyDateModel,i: number): void
  {
    const monthNames = [
      'January', 'February', 'March',
      'April', 'May', 'June', 'July',
      'August', 'September', 'October',
      'November', 'December'
      ];
    var m= event.jsdate.getMonth();
    m=m+1;
    var d= event.jsdate.getDate();
    var y= event.jsdate.getFullYear();
    var fulldate="";
    if(m>=10)
    {
      if(d < 10)
      {
        fulldate= m + '/' + '0'+ d + '/' + y;
      }
      else
      {
        fulldate= m + '/' + d + '/' + y; 
      }
    }
    else
    {
      if(d < 10)
      {
        fulldate= '0' + m + '/' + '0'+ d + '/' + y;
      }
      else
      {
        fulldate= '0' + m + '/' + d + '/' + y; 
      } 
    }
    this.EmployeeMasterService.SharedEmployees.EmployeeEducation[i].ToDatepass=fulldate;
    //event.formatted = event.jsdate.getDate() + ' ' +     monthNames[event.jsdate.getMonth()] + ', ' + event.jsdate.getFullYear();
  }

  changetdateformat()
  {
    let objemp = new EmployeeDetail();
    this.EmployeeMasterService.SharedEmployees.EmployeeEducation.forEach(temp=>
    {
      temp.FromDate=objemp.ReturnFormatdate(temp.FromDatepass);
      temp.ToDate=objemp.ReturnFormatdate(temp.ToDatepass);
    })
  }

  SaveEmpolyeeEducationDetails() :void
  {
    this.DisableSave=false;
    let t =  localStorage.getItem('userToken');
    t = 'Bearer' + t;
    this.EmployeeMasterService.SharedEmployees.IsActive=true;
    var j=0;
    var l=this.EmployeeMasterService.SharedEmployees.EmployeeEducation.length;
    this.EmployeeMasterService.SharedEmployees.EmployeeEducation.forEach(item=>
    {
      j=j+1;
      item.EmployeeId= this.EmployeeMasterService.SharedEmployees.EmployeeId;
      //let toArray =  tempedumodel.FromDate.getDay();
      if(( item.FromDatepass!=null) && ( item.ToDatepass!=null))
      {   
        if(item.EducationRefId==null)
        {
          item.EducationRefId=0;
        }
        if(item.EducationRefId> 0)
        {
          this.EmployeeMasterService.UpdateEmployeeEducationDetails(t ,item).subscribe(res=>
          {
            this.EduRefId=Number(res);        
            if(this.EduRefId>0)
            {
              this.EmployeeMasterService.SaveOrUpdate=2;
              this.Tabindex=4  
              this.notificationsService.emit(this.Tabindex); 
              if(j==l)
              {
                this.rout.navigateByUrl('/Employee/EmployeeDetails/ExpriencDetails'); 
              } 
            }
          });                  
        }                             
        else
        {
          this.EmployeeMasterService.AddEmployeeEducationDetails(t ,item).subscribe(res=>
          {
            this.EduRefId=Number(res);         
            if(this.EduRefId>0)
            {
              this.EmployeeMasterService.SaveOrUpdate=1;          
              item.EducationRefId=Number(this.EduRefId); 
              this.Tabindex=4         
              this.notificationsService.emit(this.Tabindex);
              if(j==l)
              {
                this.rout.navigateByUrl('/Employee/EmployeeDetails/ExpriencDetails');
              }
            }
          }); 
        }
      }
    });
  }

  RefreshPage()
  {
    this.rout.navigateByUrl('/Employee/EmployeeOffer', {skipLocationChange: true}).then(()=>this.rout.navigate(["/Employee/EmployeeDetails"]));
  }
}